import {
  CLEAR_FILTERS,
  SEARCH,
} from 'components/PLP/ArrangementsListFilters/translations/constants';

export const plpFilterChipsCommonLocale = {
  [SEARCH]: 'Search: {{text}}',
  [CLEAR_FILTERS]: 'Clear All Filters',
};
